import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Paging } from '../../../../core/model/paging/paging';
import { BaseTableComponent } from '../../../../core/helpers/table/basetable';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { UsersService } from '../../../../core/service/api/user.service';
import { User, UserData, UserListData } from '../../../../core/model/user/user';
import moment from 'moment';
import { Store } from '@ngrx/store';
import { selectFilterState } from '../../../../core/store/filter/filter.selectors';
import { Helpers } from '../../../../core/helpers';
import { LocationsService } from '../../../../core/service/api/location.service';
import { LocationS, LocationSListData } from '../../../../core/model/location/location';
import { NzSelectSizeType } from 'ng-zorro-antd/select';
import { Visible_Sections_K } from '../../../../core/model/constant/visible_sections/visible_sections';
import { Role } from '../../../../core/model/role/role';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { Role_K } from '../../../../core/model/constant/role/role';
import { Brand_K } from '../../../../core/model/constant/brand/brand';
import { SharedService } from '../../../../core/service/app/shared.service';
import { Account, AccountRequest } from '../../../../core/model/account/account';
import { AccountService } from '../../../../core/service/api/account.service';
import { LocationGroupService } from '../../../../core/service/api/location-group.service';

@Component({
	selector: 'app-list',
	templateUrl: './list.component.html',
	styleUrl: './list.component.scss'
})
export class AccountListComponent extends BaseTableComponent implements OnInit, OnDestroy {
	private _subscriptions: Array<Subscription> = [];
	_accounts: Account[] = []; // Oggetti mostrati in tabella
	_accountRequest: AccountRequest = new AccountRequest(); // Oggetto per il form
	_isVisible: boolean = false;
	_isEdit: boolean = false;
	_modalType: string = '';
	// helpers = Helpers;
	Helpers = Helpers;
	// permissionGroups: string[] = [
	//     'ADMIN',
	//     'EDITOR',
	//     'EDITOR',
	//     'VIEWER',
	// ];

	constructor(
		private _accountService: AccountService,
		private _tranlateService: TranslateService,
		private _nzMessageService: NzMessageService,
		private _locationGroupService: LocationGroupService
	) {
		super();
	}

	ngOnInit() {
		this.GETAccounts();
	}

	openModal(type: string, selectedAccount?: Account) {
		switch (type) {
			case 'CREATE':
				this._modalType = this._tranlateService.instant('modal.create');
				this._isVisible = true;
				this._isEdit = false;
				this._accountRequest = new AccountRequest();
				this._accountRequest.password = '!ChangeMe1';
				this.GETLocationsGroupsAll(); // Carica i gruppi location all'apertura del modal
				break;
			case 'EDIT':
				this._modalType = this._tranlateService.instant('modal.edit');
				this._isVisible = true;
				this._isEdit = true;
				this._accountRequest = new AccountRequest();
				if (selectedAccount) {
					this._accountRequest.uuid = selectedAccount.uuid;
					this._accountRequest.username = selectedAccount.username;
					this._accountRequest.permission_group_name = selectedAccount.permissions_group.toUpperCase();
					this._accountRequest.locations_groups = Array.isArray(selectedAccount.locations_groups) ? [...selectedAccount.locations_groups] : [];
				}
				this.GETLocationsGroupsAll();
				break;
			case 'DELETE':
				if (selectedAccount) {
					this.DELETEAccount(selectedAccount.uuid);
				}
				break;
		}
	}

	noDelete(): void { }

	private GETAccounts() {
		this._loading = true;
		this._subscriptions.push(this._accountService.GETAccounts(this._paging).subscribe({
			next: (response: any) => {
				this._accounts = (response && response.data && Array.isArray(response.data.data)) ? response.data.data : [];
				this._totalItems = (response && response.data && typeof response.data.count === 'number') ? response.data.count : 0;
				this._loading = false;
			},
			error: () => { this._loading = false; }
		}));
	}

	private DELETEAccount(uuid: string) {
		this._loading = true;
		this._subscriptions.push(this._accountService.DELETEAccount(uuid).subscribe({
			next: () => {
				this._nzMessageService.success(this._tranlateService.instant('alert.success.accountDeleted'));
				this.GETAccounts();
				this._loading = false;
			},
			error: (err: any) => {
				this._nzMessageService.error(this._tranlateService.instant('alert.error.accountDeleted'));
				this._loading = false;
				throw new Error(err);
			}
		}));
	}

	handleCancel(): void {
		this._isVisible = false;
	}

	handleOk(): void {
		this._loading = true;
		// Blocca se non sono stati selezionati location group
		if (!this._accountRequest.locations_groups || this._accountRequest.locations_groups.length === 0) {
			this._nzMessageService.error(this._tranlateService.instant('alert.error.requiredField'));
			this._isVisible = true; // Mantieni il modal aperto
			return;
		}
		this._isVisible = false;

		// Filtra eventuali null/undefined da locations_groups PRIMA della POST/PUT
		if (Array.isArray(this._accountRequest.locations_groups)) {
			this._accountRequest.locations_groups = this._accountRequest.locations_groups.filter((id: any) => typeof id === 'string' && !!id);
		} else {
			this._accountRequest.locations_groups = [];
		}

		if (this._isEdit) {
			const body = this._accountRequest.dtoUpdate();
			this._subscriptions.push(this._accountService.UPDATEAccount(this._accountRequest.uuid, body).subscribe({
				next: () => {
					this._nzMessageService.success(this._tranlateService.instant('alert.success.accountUpdated'));
					this.GETAccounts();
					this._loading = false;
				},
				error: (err: any) => {
					this._nzMessageService.error(this._tranlateService.instant('alert.error.accountUpdated'));
					this._loading = false;
					throw new Error(err);
				}
			}));
		} else {
			const body = this._accountRequest.dtoCreate();
			this._subscriptions.push(this._accountService.POSTAccount(body).subscribe({
				next: () => {
					this._nzMessageService.success(this._tranlateService.instant('alert.success.accountCreated'));
					this.GETAccounts();
					this._loading = false;
				},
				error: (err: any) => {
					this._nzMessageService.error(this._tranlateService.instant('alert.error.accountCreated'));
					this._loading = false;
					throw new Error(err);
				}
			}));
		}
	}

	_locations_groups: any
	private GETLocationsGroupsAll() {
		if (Helpers.getRoleFromLS() == 'Editor') {
			this._subscriptions.push(this._locationGroupService.GETLocationGroupById(Helpers.getLocationsGroupsHiddenID()[0]).subscribe({
				next: (response: any) => {
					if (response.success) {
						this._locations_groups = response.data.id ? [response.data] : [];
					} else {
						this._nzMessageService.error(this._tranlateService.instant('alert.error.locationGroups'));
					}
				},
				error: (err: any) => {
					this._nzMessageService.error(this._tranlateService.instant('alert.error.locationGroups'));
					throw new Error(err);
				}

			}))
		} else {
			this._subscriptions.push(this._locationGroupService.GETLocationGroupsAll().subscribe({
				next: (response: any) => {
					if (response.success) {
						this._locations_groups = response.data;
					} else {
						this._nzMessageService.error(this._tranlateService.instant('alert.error.locationGroups'));
					}
				},
				error: (err: any) => {
					this._nzMessageService.error(this._tranlateService.instant('alert.error.locationGroups'));
					throw new Error(err);
				}

			}))
		}
	}

	onQueryChange(params: NzTableQueryParams) {
		this.onQueryParamsChange(params, () => this.GETAccounts());
	}

	/**
	 * Parsing sicuro per il campo metadata dalla textarea JSON.
	 * Usato dal template per evitare errori di compilazione.
	 */
	parseJson(str: string): any {
		try {
			return str ? JSON.parse(str) : {};
		} catch {
			return {};
		}
	}

	/**
	 * Debug: Logga i valori selezionati nella select dei location group
	 */
	onLocationsGroupChange(event: any) {
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach(sub => sub.unsubscribe());
	}
}